<template>
  <VCard>
    <VCardText>
      <VResponsive :aspect-ratio="16/9">
        <OfficeInterviewMediaRecorder
          :interview="interview"
          :media-server-client="mediaServerHttpClient"
          @upload-error="uploadError"
          @error="error"
          @started="started"
          @stopped="stopped"
        >
          <template #start-button="{ click }">
            <VBtn color="success" :loading="loading" @click="startRecording(click)">
              {{ $t('recordInterview') }}
            </VBtn>
          </template>
        </OfficeInterviewMediaRecorder>
      </VResponsive>
    </VCardText>
  </VCard>
</template>

<script>
import OfficeInterviewRecorder from '@huntica/huntica-interview-module/src/components/OfficeInterviewRecorder.vue';
import { candidateInterviewType } from '@/enums';
import mediaServerHttpClient from '../../mediaServerHttpClient';
import ValidationMixin from '../../mixins/ValidationMixin';
import OfficeInterview from '../../orm/models/OfficeInterview/OfficeInterview';

export default {
  name: 'OfficeInterviewRecorder',
  components: {
    OfficeInterviewMediaRecorder: OfficeInterviewRecorder,
  },
  mixins: [ValidationMixin],
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    resume: {
      type: Boolean,
      default: false,
    },
    overwrite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      mediaServerHttpClient,
      recorded: false,
    };
  },
  computed: {
    interview() {
      return OfficeInterview.query()
        .withAllRecursive()
        .where('candidateId', this.candidate.id)
        .where('type', candidateInterviewType.OFFICE_INTERVIEW)
        .orderBy('id', 'desc')
        .first();
    },
  },
  methods: {
    async startRecording(action) {
      this.withApiErrorHandling(async () => {
        if (this.resume) {
          if (this.candidate.officeInterview === null) {
            throw new Error('Can not resume in-person interview (not created yet)');
          }
          await this.resumeInterview();
        } else if (this.overwrite) {
          if (this.candidate.officeInterview === null) {
            throw new Error('Can not overwrite in-person interview (not created yet)');
          }
          await this.overwriteInterview();
        } else {
          await this.recordInterview();
        }
        await action();
      }, (error) => {
        if (error.errors && Object.keys(error.errors).length > 0) {
          this.$toast.error(
            Object.values(error.errors).map((errors) => errors.join(', ')).join('\n'),
          );
        } else {
          this.$toast.error(error.message);
        }
      }, 'loading');
    },
    async resumeInterview() {
      await OfficeInterview.api().continuePublication(this.interview.id);
    },
    async overwriteInterview() {
      await OfficeInterview.api().destroy(this.interview.id);
      await OfficeInterview.delete(this.interview.id);
      await this.recordInterview();
    },
    async recordInterview() {
      await OfficeInterview.api().store(this.candidate.id);
      await OfficeInterview.api().startPublication(this.interview.id);
    },
    started() {
      this.$emit('started');
    },
    async stopped() {
      this.recorded = true;
      await this.withApiErrorHandling(async () => {
        await OfficeInterview.api().stopPublication(this.interview.id);
      }, (e) => this.$toast.error(e.message));
      this.$emit('stopped');
    },
    error() {
      this.$emit('error');
    },
    uploadError() {
      this.$emit('error');
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
recordInterview: Record the interview
</i18n>

<i18n locale="ru" lang="yaml">
recordInterview: Записать собеседование
</i18n>
